import { jsx, jsxs } from 'react/jsx-runtime';

// Illustration exported from Figma (EXP-120). Multicolour, so it cannot live in
// @belong/icons, whose svgr pipeline rewrites #325E77 to currentColor. Inlined
// rather than referenced by path because @belong/ui's Image resolves local srcs
// through belonghome.imgix.net, a bucket this repo cannot publish to.
function FoundersFeedbackIllustration() {
  return jsx("svg", {
    viewBox: "0 0 255 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "block h-auto w-full",
    "aria-hidden": "true",
    focusable: "false",
    children: jsx("g", {
      children: jsxs("g", {
        children: [jsxs("g", {
          children: [jsx("path", {
            d: "M214.085 48.0253C185.859 98.0211 49.2668 82.964 74.8761 43.7632C75.8946 42.2997 77.4883 41.0061 79.5204 39.9931C81.5523 38.9802 83.9624 38.2777 86.5445 37.9462C89.0911 37.599 91.7345 37.5952 94.2838 37.9353C96.8331 38.2752 99.2257 38.9502 101.288 39.9121C105.519 41.9835 108.493 44.8353 109.752 48.0255C111.01 51.2157 110.483 54.5664 108.25 57.5579C89.8823 83.3141 30.6548 64.4874 21 32.7527",
            stroke: "#D6E1E4",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "3 4"
          }), jsxs("g", {
            children: [jsx("path", {
              d: "M207.015 40.626C206.852 40.5795 206.707 40.4853 206.598 40.3556C206.49 40.2258 206.422 40.0664 206.405 39.898C206.388 39.7296 206.422 39.5599 206.502 39.4109C206.582 39.2618 206.705 39.1402 206.855 39.0618L231.619 26.1067C231.773 26.0261 231.949 25.9949 232.121 26.0175C232.294 26.0401 232.455 26.1155 232.584 26.2332C232.712 26.351 232.801 26.5054 232.838 26.6755C232.876 26.8456 232.86 27.0231 232.793 27.1838L222.02 52.9713C221.955 53.1279 221.844 53.2614 221.703 53.3545C221.561 53.4476 221.395 53.4961 221.225 53.4936C221.055 53.4911 220.891 53.4378 220.752 53.3406C220.613 53.2434 220.506 53.1066 220.446 52.9482L216.963 43.8242C216.916 43.7013 216.841 43.5911 216.744 43.5021C216.647 43.4132 216.531 43.3481 216.404 43.312L207.015 40.626Z",
              fill: "#3EE4A9",
              stroke: "#325E77",
              strokeWidth: "0.547944",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), jsx("path", {
              d: "M216.963 43.8244L220.446 52.9484C220.507 53.1065 220.613 53.2428 220.752 53.3398C220.891 53.4368 221.055 53.49 221.225 53.4926C221.394 53.4952 221.56 53.447 221.702 53.3542C221.843 53.2615 221.954 53.1285 222.019 52.9723L232.794 27.1832C232.861 27.0225 232.877 26.8447 232.84 26.6745C232.802 26.5042 232.713 26.3497 232.584 26.232L216.744 43.5023C216.841 43.5913 216.916 43.7016 216.963 43.8244Z",
              fill: "#C2F7E4",
              stroke: "#325E77",
              strokeWidth: "0.547944",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })]
          })]
        }), jsxs("g", {
          children: [jsxs("g", {
            children: [jsx("path", {
              d: "M128.413 23.9688V93.2783H120.205V23.9688H128.413Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M120.814 23.9688V93.2783H87.6797V23.9688H120.814Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M120.814 66.8306V75.647H87.6797V66.8306H120.814Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M120.814 49.5034V58.3198H87.6797V49.5034H120.814Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M120.814 32.1763V40.9927H87.6797V32.1763H120.814Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M120.814 58.0151V66.8315H87.6797V58.0151H120.814Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M120.814 40.6875V49.5039H87.6797V40.6875H120.814Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M120.814 23.3604V32.1768H87.6797V23.3604H120.814Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsxs("g", {
              children: [jsx("path", {
                d: "M104.399 79.5981V92.9741H95.583V79.5981H104.399Z",
                fill: "#F4FBFF",
                stroke: "#325E77",
                strokeWidth: "0.303986"
              }), jsx("path", {
                d: "M112.911 79.5981V92.9741H104.095V79.5981H112.911Z",
                fill: "#F4FBFF",
                stroke: "#325E77",
                strokeWidth: "0.303986"
              })]
            }), jsx("path", {
              d: "M121.422 21.8408V23.9688H86.1592V21.8408H121.422Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M129.022 21.8408V23.9688H121.423V21.8408H129.022Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M122.638 19.7129V21.8408H85.2471V19.7129H122.638Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M115.739 11.5078V19.8086H92.1455V11.5078H115.739Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.3"
            }), jsxs("g", {
              children: [jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M102.631 13.6633C102.837 13.6633 103.004 13.8301 103.004 14.036V17.3501H102.259V14.036C102.259 13.8301 102.425 13.6633 102.631 13.6633ZM105.586 15.0354C105.854 15.3021 105.988 15.6291 105.988 16.0166C105.988 16.4041 105.854 16.7303 105.586 16.9953C105.318 17.2603 104.98 17.3927 104.575 17.3927C104.169 17.3927 103.832 17.2603 103.564 16.9953C103.295 16.7303 103.161 16.4041 103.161 16.0166C103.161 15.6291 103.295 15.3021 103.564 15.0354C103.832 14.7688 104.169 14.6355 104.575 14.6355C104.98 14.6355 105.318 14.7688 105.586 15.0354ZM105.108 16.5507C105.247 16.4134 105.317 16.2353 105.317 16.0167C105.317 15.7981 105.247 15.6193 105.108 15.4801C104.969 15.3411 104.791 15.2715 104.574 15.2715C104.357 15.2715 104.179 15.3411 104.04 15.4801C103.901 15.6193 103.831 15.7981 103.831 16.0167C103.831 16.2353 103.901 16.4134 104.04 16.5507C104.179 16.6882 104.357 16.7569 104.574 16.7569C104.791 16.7569 104.969 16.6882 105.108 16.5507ZM98.9531 15.0166C99.2214 15.2815 99.3556 15.6062 99.3556 15.9911C99.3556 16.376 99.2214 16.6999 98.9531 16.9631C98.6848 17.2263 98.3478 17.3578 97.9419 17.3578C97.5362 17.3578 97.1991 17.2263 96.9308 16.9631C96.6625 16.6999 96.5283 16.376 96.5283 15.9911C96.5283 15.955 96.5298 15.9195 96.5323 15.8845C96.5299 15.8678 96.5283 15.8508 96.5283 15.8335V14.0283C96.5283 13.8239 96.6952 13.6582 96.901 13.6582C97.1068 13.6582 97.2736 13.8239 97.2736 14.0283V14.7689C97.4706 14.6694 97.6933 14.6195 97.9419 14.6195C98.3478 14.6195 98.6848 14.7519 98.9531 15.0166ZM98.4772 16.5217C98.6163 16.3853 98.6859 16.2084 98.6859 15.9913C98.6859 15.7742 98.6163 15.5966 98.4772 15.4584C98.3381 15.3203 98.16 15.2512 97.943 15.2512C97.7261 15.2512 97.548 15.3203 97.4089 15.4584C97.2698 15.5966 97.2002 15.7742 97.2002 15.9913C97.2002 16.2084 97.2698 16.3853 97.4089 16.5217C97.548 16.6582 97.7261 16.7265 97.943 16.7265C98.16 16.7265 98.3381 16.6582 98.4772 16.5217ZM107.621 14.6135C107.9 14.6135 108.134 14.7126 108.323 14.9107C108.512 15.1089 108.606 15.373 108.606 15.7032V17.3229H107.867V15.8172C107.867 15.4077 107.718 15.2029 107.419 15.2029C107.271 15.2029 107.142 15.2566 107.032 15.3639C106.922 15.4713 106.867 15.6289 106.867 15.837V17.3229H106.143C106.135 17.3229 106.128 17.3162 106.128 17.3079V14.9023C106.128 14.6971 106.293 14.5308 106.497 14.5308C106.702 14.5308 106.867 14.6971 106.867 14.9023V14.9552C107.09 14.7275 107.342 14.6135 107.621 14.6135ZM101.734 14.9683C101.988 15.1903 102.115 15.495 102.115 15.8824V16.2799H100.189C100.212 16.4257 100.287 16.5449 100.415 16.6376C100.543 16.7303 100.687 16.7767 100.847 16.7767C100.984 16.7767 101.108 16.7519 101.219 16.7029C101.219 16.7031 101.219 16.7032 101.219 16.7034C101.256 16.6871 101.297 16.6779 101.34 16.6779C101.507 16.6779 101.643 16.8152 101.643 16.9846C101.643 17.1175 101.559 17.2303 101.442 17.2729C101.259 17.3525 101.062 17.3927 100.85 17.3927C100.449 17.3927 100.117 17.2678 99.8549 17.0176C99.5929 16.7676 99.4619 16.4323 99.4619 16.0116C99.4619 15.5911 99.5954 15.2565 99.8623 15.0081C100.129 14.7597 100.444 14.6355 100.808 14.6355C101.171 14.6355 101.48 14.7465 101.734 14.9683ZM100.208 15.7483H101.367C101.351 15.5893 101.292 15.4668 101.19 15.3806C101.089 15.2945 100.965 15.2515 100.82 15.2515C100.674 15.2515 100.54 15.2962 100.419 15.3857C100.298 15.475 100.228 15.596 100.208 15.7483ZM111.2 14.6367C111.405 14.6367 111.572 14.8035 111.572 15.0093V16.0537C111.572 16.0633 111.572 16.0727 111.571 16.0821C111.556 16.4409 111.423 16.7454 111.17 16.9952C110.902 17.2603 110.564 17.3927 110.159 17.3927C109.753 17.3927 109.416 17.2603 109.148 16.9952C108.879 16.7303 108.745 16.4041 108.745 16.0165C108.745 15.629 108.879 15.3021 109.148 15.0353C109.416 14.7688 109.753 14.6354 110.159 14.6354C110.174 14.6354 110.19 14.6363 110.205 14.6367H111.192V14.6368C111.195 14.6368 111.197 14.6367 111.2 14.6367ZM110.694 16.5507C110.833 16.4134 110.903 16.2353 110.903 16.0167C110.903 15.7981 110.833 15.6193 110.694 15.4801C110.555 15.3411 110.377 15.2715 110.16 15.2715C109.943 15.2715 109.765 15.3411 109.626 15.4801C109.487 15.6193 109.417 15.7981 109.417 16.0167C109.417 16.2353 109.487 16.4134 109.626 16.5507C109.765 16.6882 109.943 16.7569 110.16 16.7569C110.377 16.7569 110.555 16.6882 110.694 16.5507Z",
                fill: "#325D77"
              }), jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M111.091 17.3926C110.951 17.3926 110.82 17.4717 110.761 17.6005C110.732 17.664 110.695 17.7219 110.648 17.7739C110.524 17.9137 110.365 17.9835 110.171 17.9835C109.977 17.9835 109.818 17.9137 109.694 17.7739C109.648 17.7219 109.61 17.664 109.581 17.6005C109.522 17.4717 109.391 17.3926 109.252 17.3926C108.971 17.3926 108.799 17.7042 108.944 17.9492C109.002 18.0478 109.074 18.14 109.16 18.2259C109.428 18.4953 109.765 18.63 110.171 18.63C110.577 18.63 110.914 18.4953 111.183 18.2259C111.268 18.14 111.34 18.0478 111.398 17.9492C111.543 17.7042 111.372 17.3926 111.091 17.3926Z",
                fill: "#3EE4A9"
              })]
            }), jsx("path", {
              d: "M121.82 11.5059V19.8105H115.437V11.5059H121.82Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M123.55 92.9736V94.4941H85.2471V92.9736H123.55Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M130.237 19.7129V21.8408H122.638V19.7129H130.237Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M130.846 92.9736V94.4941H123.246V92.9736H130.846Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            })]
          }), jsxs("g", {
            children: [jsx("path", {
              d: "M167.321 49.5034V93.2778H159.113V49.5034H167.321Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M159.722 49.5034V93.2778H126.587V49.5034H159.722Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M159.723 79.5981V92.9741H148.475V79.5981H159.723Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M137.835 79.5981V92.9741H126.587V79.5981H137.835Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M148.779 79.5981V92.9741H137.531V79.5981H148.779Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M159.722 66.8311V75.6475H126.587V66.8311H159.722Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M159.722 49.5034V58.3198H126.587V49.5034H159.722Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M159.722 58.0151V66.8315H126.587V58.0151H159.722Z",
              fill: "#F4FBFF",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M160.329 47.6797V49.8076H125.066V47.6797H160.329Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M167.93 47.6797V49.8076H160.33V47.6797H167.93Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M161.85 45.5518V47.6797H124.155V45.5518H161.85Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M162.458 92.9736V94.4941H124.155V92.9736H162.458Z",
              fill: "white",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M169.146 45.5518V47.6797H161.546V45.5518H169.146Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            }), jsx("path", {
              d: "M169.754 92.9736V94.4941H162.154V92.9736H169.754Z",
              fill: "#F8FBFC",
              stroke: "#325E77",
              strokeWidth: "0.303986"
            })]
          })]
        }), jsxs("g", {
          children: [jsx("path", {
            d: "M68.0214 23.9534C70.0819 30.8797 66.1373 38.1651 59.2111 40.2256C52.2848 42.2861 44.9994 38.3415 42.9389 31.4153C40.8784 24.489 44.823 17.2036 51.7493 15.1431C58.6755 13.0826 65.9609 17.0272 68.0214 23.9534Z",
            fill: "#FFCC4D"
          }), jsx("path", {
            d: "M56.2776 30.3664C54.211 30.9812 52.7674 31.1482 50.9736 31.3232C50.5635 31.3648 49.8323 31.6627 50.1718 32.8039C50.8506 35.0858 54.321 37.1582 57.9747 36.0713C61.6284 34.9843 63.4016 31.3519 62.7228 29.0701C62.3833 27.9289 61.6073 28.0786 61.242 28.2684C59.6442 29.1024 58.3448 29.7514 56.2776 30.3664Z",
            fill: "#664500"
          }), jsx("path", {
            d: "M51.4881 17.7093C50.3857 16.1936 48.2644 15.857 46.7476 16.9581C45.827 17.6264 45.3458 18.6728 45.3509 19.7277C44.3493 19.397 43.2062 19.5315 42.287 20.1993C40.7718 21.3008 40.4341 23.4239 41.5365 24.9396C41.6928 25.154 41.8718 25.3427 42.0639 25.5093C44.1657 27.6006 48.6151 28.1866 50.9995 27.5007C52.3877 25.4443 53.2052 21.0314 51.8664 18.387C51.7678 18.1524 51.643 17.9241 51.4881 17.7093ZM53.3693 17.1497C53.4639 15.2779 55.0569 13.8363 56.9283 13.9295C58.0645 13.9858 59.0394 14.5991 59.6124 15.485C60.2704 14.6606 61.3011 14.1484 62.4359 14.2052C64.3068 14.2993 65.7493 15.8928 65.6561 17.7642C65.6417 18.0294 65.5957 18.285 65.5251 18.5297C64.9082 21.4298 61.5027 24.3526 59.1304 25.0819C56.844 24.1186 53.748 20.87 53.4236 17.9238C53.3772 17.6736 53.357 17.4142 53.3693 17.1497Z",
            fill: "#DD2E44"
          })]
        }), jsxs("g", {
          children: [jsx("path", {
            d: "M90.6443 72.4915C91.557 76.5003 89.0471 80.49 85.0383 81.4027C81.03 82.3153 77.0398 79.8054 76.1272 75.7967C75.2146 71.7883 77.7248 67.7981 81.7332 66.8855C85.742 65.9728 89.7318 68.4832 90.6443 72.4915Z",
            fill: "#FFCC4D"
          }), jsx("path", {
            d: "M86.9443 76.7276L81.2987 78.013C81.0761 78.0636 80.8544 77.9245 80.8036 77.7015C80.7529 77.4785 80.8925 77.2571 81.1151 77.2065L86.7606 75.9211C86.9836 75.8704 87.2049 76.0096 87.2557 76.2326C87.3065 76.4556 87.1673 76.6769 86.9443 76.7276ZM82.1772 74.4197L79.3545 75.0624C79.1319 75.113 78.9101 74.9735 78.8594 74.7509C78.8087 74.5283 78.9482 74.3065 79.1708 74.2558L81.9936 73.6132C82.2162 73.5625 82.438 73.702 82.4887 73.9246C82.5394 74.1472 82.3998 74.369 82.1772 74.4197ZM87.4195 73.2262L84.5968 73.8688C84.3738 73.9196 84.1524 73.78 84.1017 73.5574C84.051 73.3348 84.1901 73.1131 84.4131 73.0623L87.2359 72.4197C87.4589 72.3689 87.6803 72.5085 87.731 72.7311C87.7817 72.9537 87.6425 73.1754 87.4195 73.2262Z",
            fill: "#664500"
          })]
        }), jsxs("g", {
          children: [jsx("path", {
            d: "M166.506 30.3402C169.874 31.5219 173.562 29.7495 174.744 26.3814C175.926 23.0133 174.153 19.3249 170.785 18.1431C167.417 16.9614 163.729 18.7338 162.547 22.1019C161.365 25.47 163.137 29.1584 166.506 30.3402Z",
            fill: "#FFCB4C"
          }), jsx("path", {
            d: "M166.892 25.2455C166.855 25.1856 166.834 25.1147 166.838 25.0398C166.848 24.8579 167.001 24.7268 167.179 24.7478C168.931 24.9514 169.725 26.1904 169.759 26.2432C169.858 26.4014 169.817 26.6042 169.669 26.6973C169.521 26.7897 169.321 26.7369 169.222 26.5797C169.193 26.5357 168.559 25.5723 167.143 25.4077C167.037 25.3951 166.946 25.3322 166.892 25.2455Z",
            fill: "#65471B"
          }), jsx("path", {
            d: "M167.295 22.4836C167.716 22.6313 168.207 22.3245 168.391 21.7983C168.576 21.2721 168.384 20.7257 167.963 20.578C167.542 20.4303 167.052 20.7371 166.867 21.2633C166.682 21.7896 166.874 22.3359 167.295 22.4836Z",
            fill: "#65471B"
          }), jsx("path", {
            d: "M171.199 24.2815C171.62 24.4292 172.111 24.1223 172.296 23.5961C172.48 23.0699 172.289 22.5236 171.868 22.3759C171.447 22.2281 170.956 22.535 170.771 23.0612C170.587 23.5874 170.778 24.1338 171.199 24.2815Z",
            fill: "#65471B"
          }), jsx("path", {
            d: "M166.104 30.6548C166.104 30.6548 166.609 30.6666 166.787 30.3497C166.971 30.0227 166.71 29.8525 166.71 29.8525C166.71 29.8525 167.109 29.9089 167.303 29.5064C167.486 29.1269 167.166 28.909 167.166 28.909C167.166 28.909 167.564 28.8876 167.724 28.4848C167.859 28.1456 167.547 27.8473 167.547 27.8473C167.547 27.8473 169.508 28.0434 169.709 28.0656C169.909 28.0875 170.26 28.0111 170.306 27.5924C170.352 27.1736 170.014 27.0398 169.823 27.019C169.631 26.9981 167.207 26.732 166.37 26.6407L165.812 26.5794C165.602 26.557 165.544 26.4411 165.731 26.3448C165.981 26.2165 166.172 26.0447 166.337 25.7059C166.51 25.3496 166.545 24.8469 166.535 24.6437C166.517 24.2662 166.382 23.9257 166.152 23.7442C165.793 23.4612 165.414 23.6146 165.402 24.1101C165.386 24.8512 165.052 25.347 164.563 25.5453C163.413 26.0109 162.811 26.4193 162.67 27.6906C162.517 29.0773 163.501 30.3494 164.887 30.5024L166.104 30.6548Z",
            fill: "#F19020"
          }), jsx("path", {
            d: "M166.865 19.3197C166.817 19.2675 166.785 19.2012 166.775 19.1273C166.751 18.9466 166.877 18.7897 167.056 18.7779C168.817 18.658 169.823 19.7315 169.865 19.7772C169.992 19.9146 169.989 20.1218 169.86 20.2404C169.732 20.3585 169.526 20.3432 169.399 20.2069C169.363 20.1688 168.564 19.3367 167.141 19.4336C167.035 19.4403 166.934 19.3952 166.865 19.3197ZM170.746 22.1923C170.703 22.1375 170.674 22.0692 170.67 21.9947C170.658 21.8126 170.795 21.665 170.974 21.6647C172.739 21.6651 173.671 22.8042 173.709 22.8527C173.825 22.9983 173.809 23.2049 173.673 23.3146C173.537 23.4241 173.332 23.3945 173.216 23.2501C173.182 23.2091 172.441 22.3253 171.015 22.3253C170.908 22.3245 170.811 22.2722 170.746 22.1923Z",
            fill: "#65471B"
          })]
        }), jsxs("g", {
          children: [jsx("path", {
            d: "M184.684 76.3984C190.959 78.2451 197.544 74.6546 199.391 68.3788C201.238 62.1029 197.647 55.5182 191.371 53.6715C185.095 51.8247 178.511 55.4152 176.664 61.6911C174.817 67.967 178.408 74.5516 184.684 76.3984Z",
            fill: "#FFCC4D"
          }), jsx("path", {
            d: "M187.471 66.9288C185.183 66.2558 183.744 65.5428 181.975 64.6256C181.57 64.4167 180.712 64.254 180.34 65.5167C179.597 68.0419 181.569 72.052 185.613 73.2418C189.656 74.4315 193.486 72.1288 194.229 69.6036C194.601 68.341 193.791 68.0122 193.338 67.9694C191.354 67.782 189.758 67.6018 187.471 66.9288Z",
            fill: "#664500"
          }), jsx("path", {
            d: "M181.604 65.8882C181.604 65.8882 183.312 67.0768 187.099 68.1914C190.887 69.306 192.967 69.232 192.967 69.232C192.967 69.232 190.961 71.3857 186.542 70.0853C182.123 68.7849 181.604 65.8882 181.604 65.8882Z",
            fill: "white"
          }), jsx("path", {
            d: "M184.425 63.2893C185.297 63.5458 186.295 62.7645 186.654 61.5442C187.013 60.3239 186.597 59.1267 185.726 58.8702C184.854 58.6137 183.856 59.395 183.497 60.6153C183.138 61.8356 183.554 63.0328 184.425 63.2893Z",
            fill: "#664500"
          }), jsx("path", {
            d: "M192 65.5183C192.871 65.7748 193.869 64.9935 194.228 63.7732C194.587 62.5529 194.172 61.3557 193.3 61.0992C192.428 60.8427 191.431 61.624 191.071 62.8443C190.712 64.0646 191.128 65.2618 192 65.5183Z",
            fill: "#664500"
          })]
        })]
      })
    })
  });
}

export { FoundersFeedbackIllustration };
